import axios from 'axios';
import moment from 'moment';
import React, { Component } from 'react';
import { Col, Nav, NavItem, Row, Tab } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import BeatLoader from 'react-spinners/BeatLoader';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import {
  deleteNotification,
  fetchLast5ListenedDocuments,
  fetchFlags,
  fetchFlagsByPodcastId,
  fetchNotifications,
  fetchPlaylists,
  fetchUserFields,
  fetchUserGroups,
  resetDashboardDocumentsPage,
  resetDashboardPodcastsPage,
  resetDocumentsSearchValue,
  resetRssFeed,
  setDocumentInListenNowHasFullProgress,
  setListeningToDocument,
  setPlaybackPlaylists,
  setPlayingDocumentId,
  setPlayingFromListenNowPlaylist,
  updateDashboardPodcastsPage,
  updateDocument,
  updateFlagsByPodcastId,
  updatePlaylistDataAfterFetch,
  updatePodcastDataAfterFetch,
  updateUserFields
} from '../redux/actions/app-actions';
import { fetchTagsByUser } from '../redux/actions/flag-actions';
import {
  setExpand,
  setFilterByThumbs,
  setPdfViewerDocumentId
} from '../redux/actions/pdf-actions';
import {
  resetProgress,
  sameProgress,
  setAllDocuments,
  setAllSeasons,
  setDisableSkipAheadButton,
  setDisableSkipBackButton,
  setFeedUrl,
  setFromPlaylistTab,
  setFromSkip,
  setFullSerialDocuments,
  setIsPaused,
  setNewDocumentInLast5,
  setFlagAdded,
  setOnPlaylist,
  setPlayerDocument,
  setPlayResource,
  setPodcastSeasons,
  setSeason,
  setShowSkipButton,
  setStoreProgress
} from '../redux/actions/player-actions';
import { updateUserData } from '../redux/actions/user-actions';
import {
  default as config,
  CONSTANTS,
  DOCUMENTS_PAGE_SIZE,
  NONE,
  PODCASTS_PAGE_SIZE,
  STARTING_PODCASTS_PAGE_SIZE
} from '../constants/constants';
import { firebase } from '../firebase';
import courseIcon from '../images/course.png';
import imageNotAvail from '../images/image_not_available.png';
import withAuthorization from '../session/with_authorization';
import {
  displayNotification,
  getCopyrightHtml,
  getDuration,
  getProgress
} from '../utils/utils';
import Navigation from '../components/header/Navigation';
import eventBus from '../components/EventBus';
import ModalWrapper from '../components/ModalWrapper';
import ShareFlags from '../components/share-flags/ShareFlags';
import AddToPlaylistModal from '../features/documents/components/AddToPlaylistModal';
import { updateDocumentAPI } from '../features/dashboard/apis/document';
import DashboardFlagsTab from '../features/dashboard/components/dashboard-tab/DashboardFlagsTab';
import DashboardSubscribedTab from '../features/dashboard/components/dashboard-tab/DashboardSubscribedTab';
import DocumentsTab from '../features/dashboard/components/documents-tab/DocumentsTab';
import {
  getDocument,
  getDocumentsWithUniqueIdentifier,
  getOnlyFullDocuments,
  getSummaryDocumentPayload,
  transformdocumentoPlayerDocument
} from '../features/dashboard/utils/helpers';
import LoginForm from '../features/dashboard/components/LoginForm';
import ModalPodcast from '../features/dashboard/components/add-rss/ModalPodcast';
import ModalPodcastEdit from '../features/dashboard/components/add-rss/ModalPodcastEdit';
import PlaylistsTab from '../features/dashboard/components/playlists-tab/PlaylistsTab';
import DashboardSidebar from '../features/dashboard/components/sidebar/DashboardSidebar';
import debounce from 'debounce';
import { fetchSubscribedPodcasts } from '../apis/podcasts';
import { fetchDocuments } from '../apis/documents';
import InfiniteScrollWrapper from '../features/dashboard/components/shared/InfiniteScrollWrapper';
import { scrollToTop } from '../utils/scrollToUtil';
import { hasMoreDocumentsCheck } from '../utils/hasMoreCheckUtil';
import {
  isUserStatusFree,
  isUserStatusSubscribed
} from '../utils/CheckUserStatus';
import {
  isSubscriptionTypeElite,
  isSubscriptionTypePro
} from '../utils/CheckSubscriptionType';
require('react-bootstrap-table/css/react-bootstrap-table.css');
require('react-bootstrap-table/css/react-bootstrap-table.css');

const mmt = require('moment-timezone');

class DashboardPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      withPodcastId: false,
      podcastImageUrl: '',
      podcastName: '',
      podcastModal: false,
      podcastModalEdit: false,
      podcastId: null,
      artistName: '',
      webPodcast: false,
      enterpriseType: 0,
      isOwner: false,
      loading: true,
      playerKey: 0,
      key: '1',
      loader: false,
      podcasts: [],
      sorting: 'asc',
      searchUi: false,
      decoration: false,
      fetchingPodcasts: true,
      addToPlaylist: false,
      documentoAdd: null,
      refreshNew: false,
      error: null,
      isNew: false,
      documentDeleted: false,
      updateDashboard: false,
      reload: false,
      openMyPro: 'block',
      openMyPods: 'block',
      authScheme: false,
      podcastDesc: '',
      playlists: [],
      podcastType: '',
      seasonCount: 0,
      playSerial: false,
      selectSeason: false,
      goToNextSeason: false,
      fromHandleProgress: false,
      goToNextSeasonFromSeeAll: false,
      fromPlaylistTabSingleDocument: false,
      fromLast5Listened: false,
      showPlayButton: false,
      feedUrl: '',
      shareModalOpen: false,
      flagsToShare: [],
      searchValue: '',
      page: 1,
      hasMorePodcasts: true,
      hasMoreDocuments: true,
      loadingPodcasts: false,
      isLoadingDocuments: false,
      isPodcastUnavailable: false
    };

    this.myNav = React.createRef();
    this.mediaChild = React.createRef();

    this.flagsTab = React.createRef();

    this.expandComponent = this.expandComponent.bind(this);

    this._mounted = false;

    this.debouncedSearch = debounce(this.search, 300);
  }

  setErrorHandler = (err) => {
    this.setState({ error: err });

    this.interval = setTimeout(() => {
      if (this.state.error) this.setState({ error: null });
    }, 3000);
  };

  componentWillMount() {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.props.dispatch(fetchLast5ListenedDocuments(token));
        this.props.dispatch(fetchFlags(token));
        this.props.dispatch(fetchTagsByUser(token));
        this.props.dispatch(fetchUserFields(token));
        this.props.dispatch(fetchNotifications(token));
        this.setState({ loadingPodcasts: true });

        // Check if podcasts already exist in Redux
        if (this.props.podcasts && this.props.podcasts.length > 0) {
          const hasMorePodcasts =
            this.props.podcasts === STARTING_PODCASTS_PAGE_SIZE;

          this.setState({
            podcasts: this.props.podcasts,
            fetchingPodcasts: false,
            loadingPodcasts: false,
            hasMorePodcasts: hasMorePodcasts
          });
        } else {
          fetchSubscribedPodcasts(
            token,
            this.state.searchValue,
            0,
            STARTING_PODCASTS_PAGE_SIZE
          ).then((res) => {
            const { data } = res;
            const userIsOwner = data.some((item) => item.isOwner);

            if (data && data.length > 0) {
              data.map((d, i) => {
                localStorage.setItem(d.feedUrl, i);
              });
            }

            const hasMorePodcasts = data.length === STARTING_PODCASTS_PAGE_SIZE;

            this.setState({
              podcasts: data,
              fetchingPodcasts: false,
              loadingPodcasts: false,
              hasMorePodcasts: hasMorePodcasts
            });
            this.props.dispatch(updatePodcastDataAfterFetch(res));

            if (!this.props.podcastUser?.isOwner && userIsOwner)
              this.props.dispatch(
                updateUserData({
                  ...this.props.podcastUser,
                  isOwner: true
                })
              );
          });
        }

        const options = {
          method: 'GET',
          headers: { 'X-Firebase-Auth': token },
          url: `${config.serverURL}/invitations/msg`
        };
        let welcomeMsg = '';
        axios(options).then(function(result) {
          if (result.data.length > 0) {
            result.data.forEach((msg) => {
              welcomeMsg += ' ' + (msg !== null ? msg : '');
            });

            displayNotification(
              `<div class="contentModal">${welcomeMsg}</div>` +
                getCopyrightHtml(),
              {
                showConfirmButton: false,
                showCloseButton: true,
                allowOutsideClick: false
              }
            );
          }
        });
      });
    }
  }

  componentDidMount() {
    this._mounted = true;

    eventBus.on('onProgress', (document) => this.handleProgress(document));
    eventBus.on('onLoadSeason', (data) => this.onLoadSeason(data.season));

    //Fix the sidebar visibility issue when pressing the browser back button while being in the PDF viewer.
    this.props.dispatch(setExpand(false));

    scrollToTop();
  }

  componentWillUnmount() {
    this._mounted = false;
    clearTimeout(this.interval);
    this.props.dispatch(setAllDocuments([]));
    this.props.dispatch(setFeedUrl(null));
    this.setState({
      loader: false,
      podcasts: []
    });
    eventBus.remove('onProgress');
  }

  async componentDidUpdate(prevProps) {
    if (
      this.state.isNew &&
      prevProps.last5ListenedDocuments !== this.props.last5ListenedDocuments
    ) {
      if (firebase.auth.currentUser) {
        this.setState({ loadingPodcasts: true });
        //refresh the order of podcasts by new documents
        try {
          const token = await firebase.auth.currentUser.getIdToken();
          const response = await fetchSubscribedPodcasts(
            token,
            this.state.searchValue,
            0,
            PODCASTS_PAGE_SIZE
          );

          if (response != null) {
            this.setState({
              podcasts: response.data,
              fetchingPodcasts: false,
              loadingPodcasts: false
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
      this.setState({ isNew: false });
    }

    if (this.props.flagAdded) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.props.dispatch(fetchFlags(token));
        if (this.state.podcastId) {
          fetchFlagsByPodcastId(token, this.state.podcastId).then((res) => {
            this.props.dispatch(updateFlagsByPodcastId(res));
          });
        } else {
          this.props.dispatch(fetchFlags(token));
        }
        this.props.dispatch(setFlagAdded(false));
      });
    }

    if (this.state.updateDashboard) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.setState({ loadingPodcasts: true });

        if (this.props.podcasts && this.props.podcasts.length > 0) {
          this.setState({
            podcasts: this.props.podcasts,
            fetchingPodcasts: false
          });
        } else {
          fetchSubscribedPodcasts(
            token,
            this.state.searchValue,
            0,
            PODCASTS_PAGE_SIZE
          ).then((res) => {
            const { data } = res;
            this.props.dispatch(updatePodcastDataAfterFetch(res));
            this.setState({
              podcasts: data,
              fetchingPodcasts: false,
              loadingPodcasts: false
            });
          });
        }

        this.setState({ updateDashboard: false });
      });
    }
  }

  refresh = () => {
    firebase.auth.currentUser.getIdToken().then((token) => {
      this.state.podcastId
        ? fetchFlagsByPodcastId(token, this.state.podcastId).then((res) =>
            this.props.dispatch(updateFlagsByPodcastId(res))
          )
        : this.props.dispatch(fetchFlags(token));
    });
  };

 last5ListenedDocuments(last5Documents) {
  let array = [];
  let temp = {};

  if (last5Documents && last5Documents.length > 0) {
    last5Documents.forEach((p) => {
      if (!p) return;
      temp = {};
      temp.document = {};

      // Map episode fields to document fields
      temp.id = p.id;
      temp.document.url = p.url;
      temp.document.name = (p.documentName || p.episodeName || '') + ', ' + (p.releaseDate || '');
      temp.document.icon =
        (p.imgUrl && p.imgUrl !== '')
          ? p.imgUrl
          : (p.podcastImgUrl && p.podcastImgUrl !== '')
          ? p.podcastImgUrl
          : courseIcon;
      temp.document.description = p.description;
      temp.document.progress = p.progress;
      temp.document.duration = getDuration(p.duration);
      temp.icon = temp.document.icon;
      temp.progress = p.progress;
      temp.podcastId = p.podcastId;
      temp.artistName = p.artistName;
      temp.documentName = p.documentName || p.episodeName || '';
      temp.releaseDate = p.releaseDate;
      temp.podcastName = p.podcastName;
      temp.imgUrl = temp.document.icon;
      temp.feedUrl = p.feedUrl;
      temp.isOwner = p.isOwner;
      temp.season = p.season;
      temp.duration = getDuration(p.duration);
      temp.showThumbs = p.showThumbs;
      array.push(temp);
    });
  }
  return array;
}

  lastFlags(lastFlags) {
    let array = [];
    let array5 = [];
    let arrayAll = [];
    let temp = {};

    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour12: true
    };

    let i = 0;
    if (lastFlags && lastFlags.length > 0) {
      lastFlags.forEach((p) => {
        if (!p) return;
        temp = {};
        temp.flag = {};
        temp.document = {};

        temp.id = p.id;
        temp.tag = p.flashflag === true ? 'Untagged' : p.tag;
        temp.flag.dictation = p.dictation;
        temp.dictation = p.dictation;
        temp.flag.text = p.transcriptText;
        temp.text = p.transcriptText;
        temp.flag.url = p.url;
        temp.flag.icon = (p.imgUrl && p.imgUrl !== '') ? p.imgUrl : courseIcon;
        // Map episodeName to documentName
        temp.name = p.documentName || p.episodeName || '';
        temp.icon = (p.imgUrl && p.imgUrl !== '') ? p.imgUrl : courseIcon;
        temp.tagId = p.tags && p.tags.length > 0 ? p.tags[0].id : 0;
        temp.date = new Date(p.timestamp).toLocaleString('en-US', options);
        temp.podcastName = p.podcastName;
        temp.trackPosition = p.trackPosition;
        temp.processing = p.processing;

        // Map episode fields to document fields
        temp.document.id = p.document && p.document.id ? p.document.id : p.id;
        temp.document.url = p.url;
        temp.document.name = (p.documentName || p.episodeName || '') + (p.releaseDate ? ', ' + p.releaseDate : '');
        temp.document.icon = (p.imgUrl && p.imgUrl !== '') ? p.imgUrl : courseIcon;
        temp.document.description = p.description;
        temp.document.progress = typeof p.progress !== 'undefined' ? p.progress : p.trackPosition;
        temp.document.duration = getDuration(p.duration);
        temp.document.podcastId = p.podcastId;
        temp.document.artistName = p.artistName;
        temp.document.podcastName = p.podcastName;
        temp.document.feedUrl = p.feedUrl;
        temp.document.isOwner = p.isOwner;
        temp.document.season = p.season;
        temp.document.showThumbs = p.showThumbs;
        temp.document.images = p.images || [];
        temp.document.breakPoints = p.breakPoints || [];
        temp.document.chapters = p.chapters || [];
        temp.document.notesCount = p.notesCount;
        temp.document.associatedDocument = p.associatedEpisode || null;

        temp.documentName = p.documentName || p.episodeName || '';
        temp.releaseDate = p.releaseDate;
        temp.artistName = p.artistName;
        temp.progress = typeof p.progress !== 'undefined' ? p.progress : p.trackPosition;
        temp.isOwner = p.isOwner;
        temp.season = p.season;
        temp.feedUrl = p.feedUrl;
        temp.isShareable = p.podcastTypeIds && p.podcastTypeIds[0] === 5;

        if (i < 5) {
          array5.push(temp);
        }

        arrayAll.push(temp);
        i++;
      });
    }

    array.push(array5);
    array.push(arrayAll);

    return array;
  }

  isExpandableRow() {
    return true;
  }

  expandComponent(row) {
    let data = [];
    data = [{ text: row.text, processing: row.processing }];

    const tdStyle = () => {
      return {
        whiteSpace: 'normal',
        backgroundColor: '#28313b'
      };
    };

    return (
      <div className="noBorderSubTableTag">
        <BootstrapTable bordered={false} data={data}>
          <TableHeaderColumn dataField="processing" hidden>
            Processing
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="text"
            dataFormat={this.formatTranscript}
            tdStyle={tdStyle}
            isKey={true}
          >
            Transcript Text
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }

  formatTranscript = (cell, row) => {
    if (cell) return cell;
    if (row.processing) {
      return (
        <>
          <span>Transcription in progress</span>
          <div style={{ display: 'flex' }}>
            <BeatLoader size={10} color={'#E31690'} />
            <div style={{ marginLeft: '35%' }} onClick={this.refresh}>
              <i
                className="fa fa-refresh"
                aria-hidden="true"
                style={{ fontSize: '13pt', color: '#E31690' }}
                title="Refresh"
              ></i>
            </div>
          </div>
        </>
      );
    } else {
      return null;
    }
  };

  expandColumnComponent({ isExpandableRow, isExpanded }) {
    let content = '';

    if (isExpandableRow) {
      content = isExpanded ? (
        <i
          className="fa fa-angle-up"
          style={{ fontSize: '15pt', color: '#E31690' }}
          aria-hidden="true"
        ></i>
      ) : (
        <i
          className="fa fa-angle-down"
          style={{ fontSize: '15pt', color: '#E31690' }}
          aria-hidden="true"
        ></i>
      );
    } else {
      content = ' ';
    }
    return <div> {content} </div>;
  }

  hideSignInModal = () => this.setState({ showSignInModal: false });

  showSignInModal = () => this.setState({ showSignInModal: true });

  closeSignInModal = (e) => {
    this.props.dispatch(setAllDocuments([]));
    this.setState({
      //allDocuments: [],
      loader: false
    });
    e.preventDefault();
    this.hideSignInModal();
  };

  submitLogInForm = (e, username, password, rememberme) => {
    e.preventDefault();
    this.hideSignInModal();

    this.props.dispatch(setAllDocuments([]));
    this.setState({
      loader: true
    });

    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        const options = {
          method: 'GET',
          headers: { 'X-Firebase-Auth': token },
          url: `${
            config.serverURL
          }/podcasts/episodes?feedUrl=${encodeURIComponent(
            this.props.feedUrl
          )}&username=${encodeURIComponent(
            username
          )}&password=${encodeURIComponent(password)}`
        };
        let $this = this;
        axios(options)
          .then((result) => {
            if (result.data.status === 'unauthorized') {
              $this.props.dispatch(setAllDocuments([]));
              $this.setState({
                loader: false
              });
              swal({
                imageUrl: CONSTANTS.swalLogo,
                title:
                  '<div class="titleModal">We\'re sorry, your sign in didn\'t work</div>',
                html:
                  '<p class="contentModal">Please make sure that valid email and password are entered and try again.</p>',
                showConfirmButton: false,
                showCloseButton: true,
                background: '#121C24',
                allowOutsideClick: false
              });
            } else {
              const documents = getDocumentsWithUniqueIdentifier(
                result.data.episodes
              );
              $this.props.dispatch(setAllDocuments(documents));
              $this.setState({
                podcastDesc: result.data.podcastDescription,
                loader: false
              });
              const credentials = { username: username, password: password };
              if (rememberme) {
                sessionStorage.setItem(
                  this.props.feedUrl,
                  JSON.stringify(credentials)
                );
              }
              swal({
                imageUrl: CONSTANTS.swalLogo,
                title: '<div class="titleModal">You are now signed in.</div>',
                html: '<p class="contentModal">Welcome back to Inflo!</p>',
                showConfirmButton: false,
                showCloseButton: true,
                background: '#121C24',
                allowOutsideClick: false
              });
            }
          })
          .catch((err) => {
            $this.props.dispatch(setAllDocuments([]));
            $this.setState({
              podcastDesc: '',
              loader: false
            });
            $this.setErrorHandler(err.response);
          });
      });
    }
  };

  fetchDocumentsOfPodcast = (
    feedUrl,
    forceReload,
    season,
    reloadAll = false
  ) => {
    resetDashboardDocumentsPage();
    resetDocumentsSearchValue();
    let allSeasons = [];
    if (this.props.playerDocument === '') {
      allSeasons = this.props.allSeasons !== null ? this.props.allSeasons : [];
    } else {
      allSeasons = this.props.podcastSeasons;
      this.props.dispatch(setAllSeasons(allSeasons));
    }
    let indexForUnknownSeason = allSeasons.findIndex((s) => s === 'Unknown');
    if (indexForUnknownSeason !== -1 && indexForUnknownSeason + 1 === season) {
      season = config.unknownSeason;
    }

    if (feedUrl !== undefined && feedUrl !== null) {
      if (
        this.props.playerDocument === '' ||
        (typeof reloadAll === 'boolean' && reloadAll)
      ) {
        this.props.dispatch(setFeedUrl(feedUrl));
      }
      if (this._mounted) {
        this.setState({
          reload: false,
          fetchingDocuments: true
        });
      }
      let $this = this;
      let arrayFull = [];
      if (firebase.auth.currentUser) {
        firebase.auth.currentUser.getIdToken().then((token) => {
          fetchDocuments(
            token,
            feedUrl,
            this.state.podcastId,
            this.props.documentsSearchValue,
            0,
            DOCUMENTS_PAGE_SIZE,
            season,
            true // pass a flag to indicate episodes endpoint if needed
          )
            .then((result) => {
              const documents = getDocumentsWithUniqueIdentifier(
                result.data.episodes
              );

              if (
                result.data.status === 'empty' ||
                result.data.status === 'error'
              ) {
                this.props.dispatch(setAllDocuments(documents));
                this.props.dispatch(setAllSeasons(result.data.allSeasons));
                this.props.dispatch(setPodcastSeasons(result.data.allSeasons));
                if (this._mounted) {
                  this.setState({
                    podcastDesc: result.data.podcastDescription,
                    loader: false,
                    isLoadingDocuments: false,
                    reload: this.props.season !== NONE ? false : true,
                    fetchingDocuments: false,
                    podcastType: result.data.type,
                    seasonCount: result.data.seasonCount,
                    hasMoreDocuments: false
                  });

                  if (result.data.status === 'error') {
                    this.setState({ isPodcastUnavailable: true });
                  } else {
                    this.setState({ isPodcastUnavailable: false });
                  }
                }
              } else if (result.data.status !== 'unauthorized') {
                if (this._mounted) {
                  this.setState({
                    podcastDesc: result.data.podcastDescription,
                    loader: false,
                    isLoadingDocuments: false,
                    reload: false,
                    fetchingDocuments: false,
                    podcastType: result.data.type,
                    seasonCount: result.data.seasonCount,
                    isPodcastUnavailable: false
                  });
                }

                const hasMoreDocuments = hasMoreDocumentsCheck(documents);
                this.setState({ hasMoreDocuments: hasMoreDocuments });

                this.props.dispatch(setAllDocuments(documents));
                this.props.dispatch(setPodcastSeasons(result.data.allSeasons));
                arrayFull = getOnlyFullDocuments(documents);
                this.props.dispatch(setFullSerialDocuments(arrayFull));

                if (arrayFull.length > 0) {
                  this.setState({ showPlayButton: true });
                } else {
                  this.setState({ showPlayButton: false });
                }
                if (
                  this.props.playerDocument === '' ||
                  (typeof reloadAll === 'boolean' && reloadAll)
                ) {
                  this.props.dispatch(setFullSerialDocuments(arrayFull));
                  this.props.dispatch(setAllSeasons(result.data.allSeasons));
                  if (this.state.playSerial) {
                    this.props.dispatch(
                      setPlaybackPlaylists({
                        documents: this.props.fullDocuments
                      })
                    );
                  }
                }

                //reset dropdown
                if (this.props.season && season === NONE) {
                  if (this.state.seasonCount > 1) {
                    this.props.dispatch(setSeason(NONE));
                  }
                } else if (this.props.season && season !== NONE) {
                  if (this.state.seasonCount > 1) {
                    if (season === config.unknownSeason) {
                      this.props.dispatch(setSeason(config.unknownSeason));
                    } else {
                      this.props.dispatch(setSeason(season));
                    }
                  } else {
                    this.props.dispatch(setSeason('1'));
                  }
                }
                if (
                  (this.state.goToNextSeasonFromSeeAll ||
                    this.props.fromSkip) &&
                  this.state.showPlayButton
                ) {
                  this.playDocuments();
                }
                if (
                  this.state.playSerial &&
                  !this.state.showPlayButton &&
                  this.props.fullDocuments.length === 0
                ) {
                  this.props.dispatch(setPlayerDocument(''));
                }
              } else {
                if (sessionStorage.getItem(this.props.feedUrl) != null) {
                  const credentials = JSON.parse(
                    sessionStorage.getItem(this.props.feedUrl)
                  );
                  const username = credentials.username;
                  const password = credentials.password;
                  const options = {
                    method: 'GET',
                    headers: { 'X-Firebase-Auth': token },
                    url:
                      season !== NONE
                        ? `${
                            config.serverURL
                          }/podcasts/episodes?feedUrl=${encodeURIComponent(
                            this.props.feedUrl
                          )}&username=${encodeURIComponent(
                            username
                          )}&password=${encodeURIComponent(
                            password
                          )}&season=${season}`
                        : `${
                            config.serverURL
                          }/podcasts/episodes?feedUrl=${encodeURIComponent(
                            this.props.feedUrl
                          )}&username=${encodeURIComponent(
                            username
                          )}&password=${encodeURIComponent(password)}`
                  };
                  axios(options)
                    .then((result) => {
                      if (result.data) {
                        const documents = getDocumentsWithUniqueIdentifier(
                          result.data.episodes
                        );

                        $this.props.dispatch(setAllDocuments(documents));
                        $this.props.dispatch(
                          setPodcastSeasons(result.data.allSeasons)
                        );
                        arrayFull = getOnlyFullDocuments(documents);
                        $this.props.dispatch(setFullSerialDocuments(arrayFull));

                        if (arrayFull.length > 0) {
                          $this.setState({ showPlayButton: true });
                        } else {
                          $this.setState({ showPlayButton: false });
                        }
                        if (
                          $this.props.playerDocument === '' ||
                          (typeof reloadAll === 'boolean' && reloadAll)
                        ) {
                          $this.props.dispatch(
                            setFullSerialDocuments(arrayFull)
                          );
                          $this.props.dispatch(
                            setAllSeasons(result.data.allSeasons)
                          );
                        }
                        $this.setState({
                          podcastDesc: result.data.podcastDescription,
                          loader: false,
                          isLoadingDocuments: false,
                          reload: false,
                          fetchingDocuments: false,
                          podcastType: result.data.type,
                          seasonCount: result.data.seasonCount,
                          isPodcastUnavailable: false
                        });
                      }
                    })
                    .catch((err) => {
                      $this.props.dispatch(setAllDocuments([]));
                      $this.props.dispatch(setAllSeasons([]));
                      $this.props.dispatch(setPodcastSeasons([]));
                      $this.setState({
                        podcastDesc: '',
                        loader: false,
                        isLoadingDocuments: false,
                        reload: false,
                        fetchingDocuments: false,
                        podcastType: '',
                        seasonCount: 0,
                        isPodcastUnavailable: true,
                        hasMoreDocuments: false
                      });
                      $this.setErrorHandler(err.response);
                    });
                } else {
                  $this.showSignInModal();
                }
              }
            })
            .catch(function(err) {
              $this.props.dispatch(setAllDocuments([]));
              $this.props.dispatch(setAllSeasons([]));
              $this.props.dispatch(setPodcastSeasons([]));
              $this.setState({
                podcastDesc: '',
                loader: false,
                isLoadingDocuments: false,
                reload: false,
                fetchingDocuments: false,
                podcastType: '',
                seasonCount: 0,
                isPodcastUnavailable: true,
                hasMoreDocuments: false
              });
              $this.setErrorHandler(err.response);
            });
        });
      }
    }
  };

  reloadDocumentsAndFlags = (
    key,
    id,
    podcastId,
    name,
    imageUrl,
    feedUrl,
    artistName,
    webPodcast,
    forceReload,
    authScheme,
    enterpriseType,
    isOwner
  ) => {
    this.props.dispatch(setFeedUrl(feedUrl));

    scrollToTop();
    if (this.state.podcastId === podcastId) {
      if (this.state.key == '1' || key == '1') {
        this.setState({ key: '3', decoration: true, id });
      }

      return;
    }

    resetDashboardDocumentsPage();
    resetDocumentsSearchValue();
    localStorage.setItem('podcastName', name);
    this.props.dispatch(setFromPlaylistTab(false));
    this.props.dispatch(setSeason(NONE));
    this.setState({
      playSerial: false,
      selectSeason: false,
      fromPlaylistTabSingleDocument: false
    });
    if (this.state.key == '1' || key == '1') {
      this.setState({ key: '3', decoration: true, id });
    }
    firebase.auth.currentUser.getIdToken().then((token) => {
      this.props.dispatch(setAllDocuments([]));
      this.props.dispatch(setPodcastSeasons([]));
      this.setState(
        {
          id,
          podcastId,
          artistName,
          withPodcastId: true,
          podcastImageUrl: imageUrl,
          podcastName: name,
          webPodcast,
          authScheme,
          loader: true,
          fetchingDocuments: true,
          podcastDesc: '',
          feedUrl: feedUrl,
          enterpriseType: enterpriseType,
          isOwner: isOwner
        },
        () => scrollToTop()
      );
      if (authScheme === 'Basic') {
        if (sessionStorage.getItem(this.props.feedUrl) != null) {
          const credentials = JSON.parse(
            sessionStorage.getItem(this.props.feedUrl)
          );
          const username = credentials.username;
          const password = credentials.password;
          const options = {
            method: 'GET',
            headers: { 'X-Firebase-Auth': token },
            url: `${
              config.serverURL
            }/podcasts/episodes?feedUrl=${encodeURIComponent(
              this.props.feedUrl
            )}&username=${encodeURIComponent(
              username
            )}&password=${encodeURIComponent(password)}`
          };
          axios(options)
            .then((result) => {
              if (result.data) {
                const documents = getDocumentsWithUniqueIdentifier(
                  result.data.episodes
                );
                this.props.dispatch(setAllDocuments(documents));
                this.props.dispatch(setPodcastSeasons(result.data.allSeasons));
                let arrayFull = getOnlyFullDocuments(documents);
                this.props.dispatch(setFullSerialDocuments(arrayFull));

                if (arrayFull.length > 0) {
                  this.setState({ showPlayButton: true });
                } else {
                  this.setState({ showPlayButton: false });
                }
                if (this.props.playerDocument === '') {
                  this.props.dispatch(setFullSerialDocuments(arrayFull));
                  this.props.dispatch(setAllSeasons(result.data.allSeasons));
                }
                this.setState({
                  podcastDesc: result.data.podcastDescription,
                  loader: false,
                  reload: false,
                  fetchingDocuments: false,
                  podcastType: result.data.type,
                  seasonCount: result.data.seasonCount,
                  allSeasons: result.data.allSeasons
                });
              }
            })
            .catch((err) => {
              this.props.dispatch(setAllDocuments([]));
              this.props.dispatch(setAllSeasons([]));
              this.props.dispatch(setPodcastSeasons([]));
              this.setState({
                podcastDesc: '',
                loader: false,
                reload: false,
                fetchingDocuments: false,
                podcastType: '',
                seasonCount: 0
              });
              this.setErrorHandler(err.response);
            });
        } else {
          this.showSignInModal();
        }
      } else {
        this.fetchDocumentsOfPodcast(feedUrl, forceReload, NONE);
        let index = localStorage.getItem(feedUrl);
        let slider1 = this.flagsTab.current.slider1;
        if (index !== null) {
          slider1?.slickGoTo(index);
        }
      }
      fetchFlagsByPodcastId(token, podcastId).then((res) => {
        this.props.dispatch(updateFlagsByPodcastId(res));
      });
    });
  };

  reloadFlags = (
    id,
    podcastId,
    name,
    imageUrl,
    feedUrl,
    artistName,
    webPodcast
  ) => {
    if (this.state.key == '1' || this.state.key == '3') {
      this.setState({ key: '2' });
    }

    firebase.auth.currentUser.getIdToken().then((token) => {
      this.props.dispatch(setFeedUrl(feedUrl));
      this.setState({
        id,
        podcastId,
        //feedUrl,
        artistName,
        withPodcastId: true,
        podcastImageUrl: imageUrl,
        podcastName: name,
        webPodcast,
        decoration: true
      });
      fetchFlagsByPodcastId(token, podcastId).then((res) => {
        this.props.dispatch(updateFlagsByPodcastId(res));
        //this.setPodcastDataToLocalStorage(feedUrl,res.data)
      });
    });
  };

  podcastModal = (mode) => {
    if (mode === 'edit' && this.state.podcastId === null) {
      this.dialog.showAlert('Please choose a podcast.');
    } else if (mode === 'edit') {
      this.props.dispatch(setFeedUrl(this.props.feedUrl));
      this.setState({
        podcastModalEdit: true,
        podcastName: this.state.podcastName,
        //feedUrl: this.props.feedUrl,
        podcastImageUrl: this.state.podcastImageUrl,
        artistName: this.state.artistName,
        podcastId: this.state.podcastId
      });
    } else {
      this.setState({ podcastModal: true });
    }
  };

  openMyPro = () => {
    this.state.openMyPro === 'block'
      ? this.setState({ openMyPro: 'none' })
      : this.setState({ openMyPro: 'block' });
  };

  openMyPods = () => {
    this.state.openMyPods === 'block'
      ? this.setState({ openMyPods: 'none' })
      : this.setState({ openMyPods: 'block' });
  };

  unsubscribe = () => {
    if (this.state.podcastId === null) {
      this.dialog.showAlert('Please choose a podcast.');
    } else {
      swal({
        imageUrl: CONSTANTS.swalLogo,
        title: '<div class="titleModal">Unsubscribe from podcast.</div>',
        html:
          '<p class="contentModal">Are you sure you want to unsubscribe from this podcast?</p>',
        showCancelButton: true,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#E31690'
      })
        .then((result) => {
          if (result) {
            if (firebase.auth.currentUser) {
              firebase.auth.currentUser.getIdToken().then((token) => {
                const options = {
                  method: 'PUT',
                  headers: { 'X-Firebase-Auth': token },
                  url: `${config.serverURL}/podcasts?podcastId=${this.state.podcastId}`
                };
                var $this = this;

                axios(options).then(function() {
                  const updatedSubscribedPodcasts = $this.state.podcasts.filter(
                    (subscribedPodcast) =>
                      subscribedPodcast.podcastId !== $this.state.podcastId
                  );
                  const updatedPodcastsPayload = {
                    data: updatedSubscribedPodcasts
                  };
                  $this.props.dispatch(
                    updatePodcastDataAfterFetch(updatedPodcastsPayload)
                  );
                  $this.setState({
                    podcasts: updatedSubscribedPodcasts,
                    fetchingPodcasts: false
                  });
                  $this.props.dispatch(setFeedUrl(''));
                  $this.setState({
                    podcastId: null,
                    podcastName: '',
                    //feedUrl: '',
                    imageUrl: '',
                    artistName: '',
                    webPodcast: false,
                    withPodcastId: false
                  });
                });
              });
            }
          }
        })
        .catch(() => {});
    }
  };

  neverListenToPodcast = () => {
    let array = [];
    let allDocuments = this.props.allDocuments;
    if (allDocuments && allDocuments.length > 0) {
      array = allDocuments.filter(function(epi) {
        return epi.progress !== 0 && epi.progress !== null;
      });
    }
    return array;
  };

  playDocuments = () => {
    let lastListenedIndex = 0;
    let documents = [];
    let lastListened = 0;
    let userFields = this.props.userFields;
    let checkedAutoPlay = userFields?.auto_play_serial
      ? 'checked'
      : 'unchecked';
    let checkedAutoPlayDontAsk = userFields?.auto_play_serial_dont_ask
      ? 'checked'
      : 'unchecked';
    this.props.dispatch(setDisableSkipAheadButton(false));
    this.props.dispatch(setDisableSkipBackButton(false));
    this.props.dispatch(resetProgress(false));
    this.props.dispatch(setFromSkip(false));
    this.setState({ goToNextSeason: false, goToNextSeasonFromSeeAll: false });

    if (this.props.playerDocument === '') {
      documents =
        this.props.fullDocuments !== null ? this.props.fullDocuments : [];
    } else {
      documents = getOnlyFullDocuments(this.props.allDocuments);
      this.props.dispatch(setFullSerialDocuments(documents));
    }

    if (documents && documents.length > 0) {
      lastListened = Math.max(...documents.map((o) => o.timestampListened));
      lastListenedIndex = documents.findIndex(
        (epi) => epi.timestampListened === lastListened
      );
      if (lastListenedIndex === -1) {
        lastListenedIndex = 0;
      }

      // Check if the dialog should be open and call getUserFields
      if (
        userFields?.auto_play_serial_dont_ask === undefined ||
        !userFields?.auto_play_serial_dont_ask
      ) {
        if (
          sessionStorage.getItem('auto_play_serial') === null ||
          sessionStorage.getItem('auto_play_serial') === 'false'
        ) {
          swal({
            imageUrl: CONSTANTS.swalLogo,
            title: '<div class="titleModal">Turn Auto Play Mode on</div>',
            html:
              '<p class="contentModal">Auto Play each document in order?<label class="switch">' +
              `<input type="checkbox" id="autoplay" name="autoplay" ${checkedAutoPlay}/>` +
              '<span class="slider round"></span>' +
              '</label></p>' +
              `<p><input type="checkbox" class="autoplay" id="autoplaydontask" name="autoplaydontask" ${checkedAutoPlayDontAsk}>` +
              '<label class="autoplaylabel" for="autoplaydontask" id="autoplaydontasklabel"> Do not ask again</label><br></p>',
            showCancelButton: true,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#E31690'
          })
            .then((result) => {
              if (result) {
                let checked1 = document.getElementById('autoplay').checked;
                let checked2 = document.getElementById('autoplaydontask')
                  .checked;
                let values = {};
                if (firebase.auth.currentUser) {
                  firebase.auth.currentUser.getIdToken().then((token) => {
                    if (checked2 && checked1) {
                      values.auto_play_serial_dont_ask = checked2;
                      values.auto_play_serial = checked1;
                      this.casesOfPlay(documents, lastListenedIndex);
                    } else if (checked2 && !checked1) {
                      values.auto_play_serial_dont_ask = checked2;
                      values.auto_play_serial = checked1;
                    } else if (!checked2 && checked1) {
                      // session-based
                      sessionStorage.setItem('auto_play_serial', true);
                      this.casesOfPlay(documents, lastListenedIndex);
                    } else {
                      // session-based
                      sessionStorage.setItem('auto_play_serial', false);
                    }
                    this.props.dispatch(updateUserFields(token, values));
                  });
                }
              }
            })
            .catch(() => {});
        } else {
          this.casesOfPlay(documents, lastListenedIndex);
        }
      }
    }
  };

  casesOfPlay = (documents, lastListenedIndex) => {
    let lastListenedDocument = {};
    let completed = 0;
    let array = [];
    let lastDocumentOfSeason = {};
    let completedLastDocumentOfSeason = 0;
    let allSeasons = [];
    let indexForUnknownSeason = allSeasons.findIndex((s) => s === 'Unknown');

    lastDocumentOfSeason = documents[documents.length - 1];
    completedLastDocumentOfSeason = getProgress(
      lastDocumentOfSeason.progress,
      getDuration(lastDocumentOfSeason.duration)
    );
    lastListenedDocument = documents[lastListenedIndex];
    if (this.props.playerDocument === '') {
      allSeasons = this.props.allSeasons !== null ? this.props.allSeasons : [];
    } else {
      allSeasons =
        this.props.podcastSeasons !== null ? this.props.podcastSeasons : [];
      this.props.dispatch(setAllSeasons(allSeasons));
    }
    array = documents.filter(function(epi) {
      return (
        epi.documentType=== 'full' && epi.season === lastListenedDocument.season
      );
    });

    //case of full documents without season..???
    completed = getProgress(
      lastListenedDocument.progress,
      getDuration(lastListenedDocument.duration)
    );

    //if first document of first season disable button back
    if (
      lastListenedDocument.season === 1 &&
      array[0].id == lastListenedDocument.id
    ) {
      this.props.dispatch(setDisableSkipBackButton(true));
    }
    if (
      array[array.length - 1].id == lastListenedDocument.id &&
      ((indexForUnknownSeason !== -1 &&
        lastListenedDocument.season === allSeasons.length - 1) ||
        this.state.seasonCount === lastListenedDocument.season)
    ) {
      this.props.dispatch(setDisableSkipAheadButton(true));
    }
    //listen to all last document of last season
    if (
      array[array.length - 1].id === lastListenedDocument.id &&
      completed >= 100 &&
      ((indexForUnknownSeason !== -1 &&
        lastListenedDocument.season === allSeasons.length - 1) ||
        this.state.seasonCount === lastListenedDocument.season)
    ) {
      // Play last document of last season from 0
      this.props.dispatch(setDisableSkipAheadButton(true));
      this.props.dispatch(resetProgress(true));
      this.props.dispatch(setSeason(documents[lastListenedIndex].season));
      this.setState({ playSerial: true, goToNextSeason: false });
      this.fetchDocumentsOfPodcast(
        documents[lastListenedIndex].feedUrl,
        false,
        documents[lastListenedIndex].season,
        true
      );
      this.onRowClickDocument(documents[lastListenedIndex], false, true);
    } else if (
      array[array.length - 1].id === lastListenedDocument.id &&
      (completed < 100 || isNaN(completed))
    ) {
      // Continue to play last document and fetch next season but don't play it if you are not in see all...(unknown season not included)
      if (
        (indexForUnknownSeason !== -1 &&
          lastListenedDocument.season === allSeasons.length - 1) ||
        this.state.seasonCount === lastListenedDocument.season ||
        lastListenedDocument.season === config.unknownSeason
      ) {
        this.setState({ goToNextSeason: false });
      } else {
        this.setState({ goToNextSeason: true });
      }
      this.props.dispatch(setSeason(documents[lastListenedIndex].season));
      this.setState({ playSerial: true });
      this.fetchDocumentsOfPodcast(
        documents[lastListenedIndex].feedUrl,
        false,
        documents[lastListenedIndex].season,
        true
      );
      this.onRowClickDocument(documents[lastListenedIndex], false, true);
    } else if (
      array[array.length - 1].id === lastListenedDocument.id &&
      completed >= 100
    ) {
      if (this.state.selectSeason) {
        swal({
          imageUrl: CONSTANTS.swalLogo,
          title: '<div class="titleModal">This season is complete.</div>',
          html:
            '<p class="contentModal">It appears you have finished this season, do you want to restart?</p>',
          showCancelButton: true,
          showCloseButton: true,
          background: '#121C24',
          allowOutsideClick: false,
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#E31690'
        }).then((result) => {
          if (result) {
            let values = {};
            // Update progress of all documents
            if (firebase.auth.currentUser) {
              firebase.auth.currentUser.getIdToken().then((token) => {
                documents.forEach((e) => {
                  if (
                    e.id !== null &&
                    e.progress !== null &&
                    e.progress !== 0
                  ) {
                    values.id = e.id;
                    values.progress = 0;
                    this.props.dispatch(updateDocument(token, values));
                  }
                });
              });
            }
            this.props.dispatch(setSeason(documents[lastListenedIndex].season));
            this.setState({ playSerial: true, goToNextSeason: false });
            this.fetchDocumentsOfPodcast(
              documents[0].feedUrl,
              false,
              documents[0].season,
              true
            );
            this.onRowClickDocument(documents[0], false, true);
          }
        });
      } else {
        this.props.dispatch(setSeason(documents[lastListenedIndex].season + 1));
        this.setState({
          playSerial: true,
          goToNextSeason: false,
          goToNextSeasonFromSeeAll: true
        });
        this.fetchDocumentsOfPodcast(
          documents[lastListenedIndex].feedUrl,
          false,
          documents[lastListenedIndex].season + 1,
          true
        );
      }
    } else if (
      completedLastDocumentOfSeason < 100 ||
      isNaN(completedLastDocumentOfSeason)
    ) {
      this.props.dispatch(setSeason(documents[lastListenedIndex].season));
      this.setState({ playSerial: true, goToNextSeason: true });
      this.fetchDocumentsOfPodcast(
        documents[lastListenedIndex].feedUrl,
        false,
        documents[lastListenedIndex].season,
        true
      );
      this.onRowClickDocument(documents[lastListenedIndex], false, true);
    } else if (this.state.selectSeason) {
      swal({
        imageUrl: CONSTANTS.swalLogo,
        title: '<div class="titleModal">Auto Play Mode</div>',
        html:
          '<p class="contentModal">It appears you have finished this season, do you want to restart?</p>',
        showCancelButton: true,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#E31690'
      }).then((result) => {
        if (result) {
          let values = {};
          // Update progress of all documents
          if (firebase.auth.currentUser) {
            firebase.auth.currentUser.getIdToken().then((token) => {
              documents.forEach((e) => {
                if (e.id !== null && e.progress !== null && e.progress !== 0) {
                  values.id = e.id;
                  values.progress = 0;
                  this.props.dispatch(updateDocument(token, values));
                }
              });
            });
          }
          this.props.dispatch(setSeason(lastDocumentOfSeason.season));
          this.setState({ playSerial: true, goToNextSeason: false });
          this.fetchDocumentsOfPodcast(
            lastDocumentOfSeason.feedUrl,
            false,
            lastDocumentOfSeason.season,
            true
          );
          this.onRowClickDocument(lastDocumentOfSeason, false, true);
        }
      });
    } else {
      this.props.dispatch(resetProgress(true));
      this.props.dispatch(setSeason(documents[lastListenedIndex].season));
      this.setState({ playSerial: true, goToNextSeason: false });
      this.fetchDocumentsOfPodcast(
        lastDocumentOfSeason.feedUrl,
        false,
        documents[lastListenedIndex].season,
        true
      );
      this.onRowClickDocument(lastDocumentOfSeason, false, true);
    }
  };

  onLoadSeason = (season) => {
    this.fetchDocumentsOfPodcast(this.props.feedUrl, false, season, true);
  };

  onPlayNextPlaylistDocument = (document) => {
    if (document !== undefined) {
      let id = document.id;
      let type = typeof id;

      this.props.dispatch(setPlayingDocumentId(document.id));
      this.props.dispatch(setListeningToDocument(true));
      this.props.dispatch(setPlayerDocument(document));
      this.props.dispatch(setIsPaused(false));
      this.props.dispatch(setFeedUrl(document.feedUrl));
      this.props.dispatch(setStoreProgress(true));
      this.setState({
        playerKey: this.state.playerKey + 1
      });
    } else {
      if (!this.state.selectSeason) {
        this.setState({ goToNextSeasonFromSeeAll: true });
      }
      this.fetchDocumentsOfPodcast(this.props.feedUrl, false, this.props.season);
    }
  };

  onDocumentSummaryClick = (row) => {
    this.props.dispatch(setPlayerDocument(row));
  };

  onRowClickDocument = (
    row,
    isListenNowPlaying = false,
    showSkipButton = false,
    isSinglePlay = false,
    fromPlaylistTab = false,
    fromPlaylistTabSingleDocument = false
  ) => {
    // save before change to another document
    if (this.props.playerDocument.progress === row.progress) {
      this.props.dispatch(sameProgress(true));
    }

    let currentId = row.id;
    let currentIndex = 0;
    let fullDocuments =
      this.props.fullDocuments !== null ? this.props.fullDocuments : [];
    let allSeasons =
      this.props.allSeasons !== null ? this.props.allSeasons : [];
    let indexForUnknownSeason = allSeasons.findIndex((s) => s === 'Unknown');
    if (fromPlaylistTab) {
      this.props.dispatch(setShowSkipButton(true));
      this.props.dispatch(setPlayResource('playlists'));
      this.props.dispatch(setFromPlaylistTab(true));
      this.setState({ playSerial: false, fromPlaylistTabSingleDocument });
    } else if (this.state.fromLast5Listened) {
      this.props.dispatch(setPlayResource('last5Listened'));
      this.setState({ fromLast5Listened: false });
    } else {
      this.props.dispatch(setPlayResource('documents'));
      //check if first document of first season and check if last document of last season
      if (typeof currentId === 'string' && currentId.startsWith('0')) {
        //non listened to document means that in fullDocuments list we have a null value for id
        currentIndex = fullDocuments.findIndex((epi) => epi.id === null);
        if (currentIndex === 0 && row.season === 1) {
          this.props.dispatch(setDisableSkipBackButton(true));
        }
        if (
          currentIndex === fullDocuments.length - 1 &&
          ((indexForUnknownSeason !== -1 &&
            row.season === allSeasons.length - 1) ||
            row.season === allSeasons.length)
        ) {
          this.props.dispatch(setDisableSkipAheadButton(true));
        }
      } else {
        currentIndex = fullDocuments.findIndex((epi) => epi.id === row.id);
        if (currentIndex === 0 && row.season === 1) {
          this.props.dispatch(setDisableSkipBackButton(true));
        }
        if (
          currentIndex === fullDocuments.length - 1 &&
          ((indexForUnknownSeason !== -1 &&
            row.season === allSeasons.length - 1) ||
            row.season === allSeasons.length)
        ) {
          this.props.dispatch(setDisableSkipAheadButton(true));
        }
      }
    }
    let userFields = this.props.userFields;
    let checkedAutoPlay = userFields?.auto_play_serial
      ? 'checked'
      : 'unchecked';
    let checkedAutoPlayDontAsk = userFields?.auto_play_serial_dont_ask
      ? 'checked'
      : 'unchecked';
    let checked1 = false;
    let checked2 = false;
    if (
      typeof isSinglePlay === 'boolean' &&
      isSinglePlay &&
      row.documentType=== 'full' &&
      (userFields?.auto_play_serial_dont_ask === undefined ||
        !userFields?.auto_play_serial_dont_ask) &&
      (sessionStorage.getItem('auto_play_serial') === null ||
        !sessionStorage.getItem('auto_play_serial'))
    ) {
      this.setState({ playSerial: true });
      this.props.dispatch(setDisableSkipAheadButton(false));
      this.props.dispatch(setDisableSkipBackButton(false));
      swal({
        imageUrl: CONSTANTS.swalLogo,
        title: '<div class="titleModal">Auto Play Mode in order?</div>',
        html:
          '<p class="contentModal">Auto Play each document in order?<label class="switch">' +
          `<input type="checkbox" id="autoplay" name="autoplay" ${checkedAutoPlay}/>` +
          '<span class="slider round"></span>' +
          '</label></p>' +
          `<p><input type="checkbox" class="autoplay" id="autoplaydontask" name="autoplaydontask" ${checkedAutoPlayDontAsk}>` +
          '<label class="autoplaylabel" for="autoplaydontask" id="autoplaydontasklabel"> Do not ask again</label><br></p>',
        showCancelButton: true,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#E31690'
      })
        .then((result) => {
          if (result) {
            checked1 = document.getElementById('autoplay').checked;
            checked2 = document.getElementById('autoplaydontask').checked;
            let values = {};
            if (firebase.auth.currentUser) {
              firebase.auth.currentUser
                .getIdToken()
                .then((token) => {
                  if (checked2 && checked1) {
                    values.auto_play_serial_dont_ask = checked2;
                    values.auto_play_serial = checked1;
                  } else if (checked2 && !checked1) {
                    values.auto_play_serial_dont_ask = checked2;
                    values.auto_play_serial = checked1;
                  } else if (!checked2 && checked1) {
                    //session based
                    sessionStorage.setItem('auto_play_serial', true);
                  } else {
                    //session based
                    sessionStorage.setItem('auto_play_serial', false);
                  }
                  this.props.dispatch(updateUserFields(token, values));
                })
                .then(() => {
                  this.onRowClickDocument(row, false, true);
                });
            }
          }
        })
        .catch(() => {});
    } else if (
      typeof isSinglePlay === 'boolean' &&
      isSinglePlay &&
      row.documentType=== 'full'
    ) {
      this.setState({ playSerial: true });
      this.props.dispatch(setDisableSkipAheadButton(false));
      this.props.dispatch(setDisableSkipBackButton(false));
      this.onRowClickDocument(row, false, true);
    } else {
      let id = row.id;
      let type = typeof id;
      this.props.dispatch(setPlaybackPlaylists({ documents: [] }));
      this.props.dispatch(setPlayingDocumentId(row.id));
      this.props.dispatch(setListeningToDocument(true));
      this.props.dispatch(setPlayingFromListenNowPlaylist(isListenNowPlaying));
      const proggress = getProgress(row.progress, getDuration(row.duration));
      if (isListenNowPlaying && proggress >= 100) {
        row.progress = 0;
        this.props.dispatch(setDocumentInListenNowHasFullProgress(true));
      }
      this.props.dispatch(setPlayerDocument(row));
      this.props.dispatch(
        setShowSkipButton(
          typeof showSkipButton === 'boolean' && showSkipButton ? true : false
        )
      );
      this.props.dispatch(setIsPaused(false));
      this.props.dispatch(setFeedUrl(row.feedUrl));
      this.props.dispatch(setStoreProgress(true));
      this.setState({
        playerKey: this.state.playerKey + 1,
        isNew: row.isNew
      });
      if (type === 'string' && id.startsWith('0')) {
        firebase.auth.currentUser.getIdToken().then((token) => {
          const options = {
            method: 'POST',
            headers: { 'X-Firebase-Auth': token },
            url: `${config.serverURL}/episodes`,
            data: { ...row, id: null }
          };
          let playerDocument = {};
          if (row.url !== null && row.url !== '') {
            axios(options)
              .then((result) => {
                let epi = result.data;
                playerDocument = {
                  document: {
                    name: epi.documentName,
                    url: epi.url
                  },
                  id: epi.id,
                  progress: epi.progress,
                  podcastId: epi.podcastId,
                  imgUrl: epi.imgUrl,
                  artistName: epi.artistName,
                  documentName: epi.documentName,
                  podcastName: epi.podcastName,
                  releaseDate: epi.releaseDate,
                  duration: epi.duration,
                  isOwner: epi.isOwner,
                  season: row.season,
                  showThumbs: row.showThumbs,
                  uuid: row.uuid
                };
                this.props.dispatch(setPlayerDocument(playerDocument));
                this.props.dispatch(setPlayingDocumentId(epi.id.toString()));
                this.props.dispatch(setNewDocumentInLast5(true));

                const documents = this.props.allDocuments.map((documentObj) => {
                  if (row.uuid === documentObj.uuid) {
                    return { ...documentObj, id: epi.id };
                  }
                  return documentObj;
                });

                this.props.dispatch(setAllDocuments(documents));
              })
              .catch(() => {
                this.setErrorHandler();
              });
          } else {
            let epi = row;
            playerDocument = {
              document: {
                name: epi.documentName,
                url: epi.url
              },
              id: epi.id,
              progress: epi.progress,
              podcastId: epi.podcastId,
              imgUrl: epi.imgUrl,
              artistName: epi.artistName,
              documentName: epi.documentName,
              podcastName: epi.podcastName,
              releaseDate: epi.releaseDate,
              duration: epi.duration,
              isOwner: epi.isOwner,
              season: row.season,
              showThumbs: row.showThumbs,
              uuid: row.uuid
            };
            this.props.dispatch(setPlayerDocument(playerDocument));
            this.props.dispatch(setPlayingDocumentId(id));
          }
        });
      } else if (type === 'string' && !id.startsWith('0')) {
        this.props.dispatch(setPlayingDocumentId(parseInt(row.id, 10)));
        this.props.dispatch(setPlayerDocument(row));
      } else {
        this.props.dispatch(setPlayingDocumentId(row.id));
      }
    }
  };

  onRowClickFlag = async (row, fromNotification) => {
    await this.props.dispatch(setIsPaused(false));
    await this.props.dispatch(setPlayerDocument(row));
    await this.props.dispatch(setPlayingDocumentId(row.id));
    if (fromNotification) {
      this.props.dispatch(setStoreProgress(false));
      this.props.dispatch(setPlayResource('notifications'));
      const array = [];
      array.push(row.id);
      this.deleteNotification(array);
    } else {
      this.props.dispatch(setStoreProgress(true));
      this.props.dispatch(setPlayResource('flags'));
    }
  };

  deleteNotification = (ids) => {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then(async (token) => {
        await this.props.dispatch(deleteNotification(token, ids));
        this.props.dispatch(fetchNotifications(token));
      });
    }
  };

  addToPlaylistHandler = (value, document) => {
    this.setState({ addToPlaylist: value, documentoAdd: document });
  };

  reloadPlaylists = () => {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        fetchPlaylists(token).then((res) => {
          const { data } = res;
          this.props.dispatch(updatePlaylistDataAfterFetch(res));
          this.setState({ playlists: data });
        });
      });
    }
  };

  handleDocumentDeleted = (hasDocumentBeenDeleted) => {
    this.setState({ documentDeleted: hasDocumentBeenDeleted });
  };

  handleProgress = (document) => {
    let row = this.props.playerDocument;
    if (row !== '') {
      if (this.props.storeProgress) {
        if (this.props.newDocumentInLast5) {
          if (firebase.auth.currentUser) {
            firebase.auth.currentUser.getIdToken().then((token) => {
              this.props.dispatch(fetchLast5ListenedDocuments(token));
              this.props.dispatch(setNewDocumentInLast5(false));
            });
          }
        }
      }
      let playingDocumentId = this.props.playingDocumentId;
      if (typeof playingDocumentId === 'string') {
        playingDocumentId = parseInt(playingDocumentId, 10);
      }

      const playingDocument = row;
      let completed = getProgress(
        playingDocument.progress,
        getDuration(playingDocument.duration)
      );

      if (this.props.playbackPlaylist.length > 0) {
        if (!this.props.listeningToDocument) {
          if (playingDocument) {
            let playlistToPlay = this.props.playbackPlaylist;
            let documentName = playingDocument.documentName;
            let index = playlistToPlay.findIndex(
              (epi) => epi.documentName === documentName
            );
            if (index > -1) {
              if (playlistToPlay[index].id === null) {
                playlistToPlay[index].id = playingDocument.id;
              }
            }
            if (!this.state.playSerial) {
              const documentIndex = playlistToPlay.findIndex(
                (epi) => epi.document.id === this.props.playingDocumentId
              );
              if (
                completed >= 100 &&
                documentIndex < this.props.playbackPlaylist.length - 1
              ) {
                if (!this.state.fromPlaylistTabSingleDocument) {
                  this.onPlayNextPlaylistDocument(
                    this.props.playbackPlaylist[documentIndex + 1].document
                  );
                }
              }
            } else {
              let indexInFullDocuments = 0;
              let fullDocuments = this.props.fullDocuments;
              indexInFullDocuments = fullDocuments.findIndex(
                (epi) =>
                  epi.id === parseInt(this.props.playingDocumentId, 10) ||
                  epi.id === this.props.playingDocumentId
              );
              if (
                completed >= 100 &&
                indexInFullDocuments < fullDocuments.length - 1
              ) {
                console.log('completed document and there are documents yet');
                if (
                  sessionStorage.getItem('auto_play_serial') === 'true' ||
                  sessionStorage.getItem('auto_play_serial') === null
                ) {
                  this.onPlayNextPlaylistDocument(
                    fullDocuments[indexInFullDocuments + 1]
                  );
                }
              } else if (completed >= 100 && this.state.goToNextSeason) {
                console.log(
                  'completed document and there are not documents yet, so go to next Season if there is any'
                );
                if (
                  fullDocuments[indexInFullDocuments].season + 1 <=
                  this.props.allSeasons.length
                ) {
                  this.props.dispatch(
                    setSeason(fullDocuments[indexInFullDocuments].season + 1)
                  );
                  this.onPlayNextPlaylistDocument();
                }
              }
            }
          }
        }
      }
      if (this.props.playingFromListenNowPlaylist) {
        if (completed >= 100 && !this.props.documentInListenNowHasFullProgress) {
          if (!this.state.documentDeleted)
            this.deleteDocumentHandler(playingDocument);
          this.handleDocumentDeleted(true);
        } else if (
          this.props.documentInListenNowHasFullProgress &&
          completed >= 100
        ) {
          this.props.dispatch(setDocumentInListenNowHasFullProgress(false));
        }
      }
    }
  };

  deleteDocumentHandler = (document) => {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        const options = {
          method: 'DELETE',
          headers: { 'X-Firebase-Auth': token },
          url: `${
            config.serverURL
          }/playlists/?playlistName=Listen Now&documentName=${encodeURIComponent(
            document.documentName
          )}&podcastId=${encodeURIComponent(document.podcastId)}`
        };
        axios(options)
          .then(() => {
            //inform child that document has been deleted.
          })
          .catch((err) => console.error(err));
      });
    }
  };

  podcastsList(podcasts) {
    let array = [];

    if (podcasts && podcasts.length > 0) {
      podcasts.forEach((p) => {
        const currDate = mmt().tz('America/Los_Angeles');

        const diffFromLs = moment(currDate)
          .startOf('day')
          .diff(moment(p.lastSuccess).startOf('day'), 'days');

        diffFromLs >= 5 ? (p.inactive = diffFromLs) : (p.inactive = 0);

        if (p.imageUrl === null) {
          p.imageUrl = imageNotAvail;
        }

        array.push(p);
      });
    }

    return array;
  }

  handleSelect = (key) => {
    this.setState({ key });
    if (key === '4') {
      this.props.dispatch(setOnPlaylist(true));
    } else {
      this.props.dispatch(setOnPlaylist(false));
    }
  };

  // Toggle searchbar visibility
  searchBar = async () => {
    const { searchUi } = this.state;

    if (searchUi && firebase.auth.currentUser) {
      try {
        const token = await firebase.auth.currentUser.getIdToken();
        const response = await fetchSubscribedPodcasts(
          token,
          '',
          0,
          STARTING_PODCASTS_PAGE_SIZE
        );

        const hasMorePodcasts =
          response.data.length === STARTING_PODCASTS_PAGE_SIZE;

        this.setState({
          podcasts: response.data,
          page: this.props.dashboardPodcastsPage,
          hasMorePodcasts,
          searchValue: ''
        });

        this.props.dispatch(updatePodcastDataAfterFetch(response));
        this.props.dispatch(resetDashboardPodcastsPage());
      } catch (error) {
        console.error(error);
      }
    }

    this.setState((prevState) => ({
      searchUi: !prevState.searchUi
    }));
  };

  // Handle searchbar functionality
  search = async (searchValue) => {
    this.setState({ searchValue });

    if (firebase.auth.currentUser) {
      try {
        const token = await firebase.auth.currentUser.getIdToken();
        const response = await fetchSubscribedPodcasts(
          token,
          searchValue,
          0,
          STARTING_PODCASTS_PAGE_SIZE
        );

        const hasMorePodcasts =
          response.data.length === STARTING_PODCASTS_PAGE_SIZE;

        this.setState({
          podcasts: response.data,
          hasMorePodcasts
        });

        this.props.dispatch(updatePodcastDataAfterFetch(response));
        this.props.dispatch(resetDashboardPodcastsPage());
      } catch (error) {
        console.error(error);
      }
    }
  };

  sortPodcast = () => {
    let podcasts = this.state.podcasts;
    let $this = this;

    if (podcasts) {
      podcasts.sort(function(a, b) {
        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if ($this.state.sorting === 'asc' && nameA < nameB) {
          return -1;
        }
        if ($this.state.sorting === 'asc' && nameA > nameB) {
          return 1;
        }
        if ($this.state.sorting === 'desc' && nameB < nameA) {
          return -1;
        }
        if ($this.state.sorting === 'desc' && nameB > nameA) {
          return 1;
        }
        return 0;
      });
    }
    this.state.sorting === 'desc'
      ? this.setState({ sorting: 'asc' })
      : this.setState({ sorting: 'desc' });
    this.setState({ podcasts: podcasts });
  };

  updateDashboard = () => {
    this.setState({ updateDashboard: true });
  };

  handleSeasonChange = (season) => {
    this.setState({
      selectSeason: season === NONE ? false : true,
      isLoadingDocuments: true
    });
    this.props.dispatch(resetDashboardDocumentsPage());
    if (this.state.feedUrl !== this.props.feedUrl) {
      if (season === NONE) {
        this.fetchDocumentsOfPodcast(this.state.feedUrl, false, undefined);
      } else {
        this.fetchDocumentsOfPodcast(this.state.feedUrl, false, season);
      }
    } else {
      this.props.dispatch(setDisableSkipBackButton(false));
      this.props.dispatch(setDisableSkipAheadButton(false));
      if (season === NONE) {
        this.props.dispatch(setSeason(NONE));
        this.fetchDocumentsOfPodcast(this.props.feedUrl, false, NONE);
      } else {
        this.props.dispatch(setSeason(season));
        this.fetchDocumentsOfPodcast(this.props.feedUrl, false, season);
      }
    }
  };

  setLoading = () => {
    this.setState({ loading: false });
  };

  handleShareModalOpen = (flag) => {
    this.setState({ shareModalOpen: true });
    this.setState({ flagsToShare: [flag] });
  };

  handleShareModalClose = () => {
    this.setState({ shareModalOpen: false });
  };

  handleShareModalInit = async (flag) => {
    const token = await firebase.auth.currentUser.getIdToken();
    if (token) {
      await this.props.dispatch(fetchUserGroups(token, flag?.feedUrl));
      this.handleShareModalOpen(flag);
    }
  };

  setPdfViewerDocumentId = (documentId) => {
    this.props.dispatch(setPdfViewerDocumentId(documentId));
  };

  setExpand = (opt) => {
    if (opt !== null && opt !== undefined) {
      this.props.dispatch(setExpand(opt));
    } else {
      this.props.dispatch(setExpand(!this.props.expand));
    }
  };

  setFilterByThumbs = () => {
    this.props.dispatch(setFilterByThumbs(false));
  };

  handlePlaySummary = async (document) => {
    this.props.dispatch(setPlayResource('documentsSummary'));
    this.props.dispatch(setDisableSkipBackButton(true));
    this.props.dispatch(setDisableSkipAheadButton(true));
    this.props.dispatch(setStoreProgress(false));

    if (document.summaryDocument.id === null) {
      // first time listening to document summary
      // the object is created in system DB
      try {
        const token = await firebase.auth.currentUser.getIdToken();
        const summaryDocument = getSummaryDocumentPayload(document);

        const response = await updateDocumentAPI(token, summaryDocument);
        const data = response.data;

        const playingDocumentId = data.id;
        const playerDocument = transformdocumentoPlayerDocument(
          document,
          data,
          true
        );
        const documents = this.props.allDocuments.map((documentObj) => {
          if (document.id === documentObj.id) {
            return getDocument(document, data);
          }
          return documentObj;
        });

        this.props.dispatch(setAllDocuments(documents));
        this.props.dispatch(setPlayerDocument(playerDocument));
        this.props.dispatch(setPlayingDocumentId(playingDocumentId));
        this.props.dispatch(setNewDocumentInLast5(true));
      } catch (error) {
        this.setErrorHandler();
      }
    } else {
      // had listened to document summary
      // the object exists in system DB
      const playingDocumentId = document.summaryDocument.id;
      const playerDocument = transformdocumentoPlayerDocument(document);

      // Keep play document progress on play after pause.
      // Update sameProgress to force player start even progress is the same.
      if (this.props.playerDocument?.id === playingDocumentId) {
        const progress = this.props.playerDocument.progress;

        playerDocument.progress = progress;
        playerDocument.document.progress = progress;
        playerDocument.summaryDocument.progress = progress;

        this.props.dispatch(sameProgress(true));
      }

      this.props.dispatch(setListeningToDocument(true));
      this.props.dispatch(setIsPaused(false));
      this.props.dispatch(setPlayingDocumentId(playingDocumentId));
      this.props.dispatch(setPlayerDocument(playerDocument));
    }
  };

  handlePlayDocument = (document) =>
    this.onRowClickDocument(document, false, false, true);

  handleAddSummaryToPlaylist = (document) => {
    const summaryDocument = transformdocumentoPlayerDocument(document);
    this.addToPlaylistHandler(true, summaryDocument);
  };

  handleAdddocumentoPlaylist = (document) =>
    this.addToPlaylistHandler(true, document);

  loadMorePodcasts = async () => {
    const { podcasts, searchValue, loadingPodcasts } = this.state;

    if (
      !this.state.hasMorePodcasts ||
      loadingPodcasts ||
      this.state.key !== '1'
    ) {
      return;
    }

    if (firebase.auth.currentUser) {
      this.setState({ loadingPodcasts: true });
      try {
        const token = await firebase.auth.currentUser.getIdToken();
        const response = await fetchSubscribedPodcasts(
          token,
          searchValue,
          this.props.dashboardPodcastsPage,
          PODCASTS_PAGE_SIZE
        );
        const newPodcasts = response.data;
        const hasMorePodcasts = newPodcasts.length === PODCASTS_PAGE_SIZE;

        const updatedPodcasts = [...podcasts, ...newPodcasts];

        this.setState({
          podcasts: updatedPodcasts,
          hasMorePodcasts
        });

        this.props.dispatch(
          updatePodcastDataAfterFetch({ data: updatedPodcasts })
        );
        this.props.dispatch(updateDashboardPodcastsPage());
      } catch (error) {
        console.error(error);
      } finally {
        this.setState({ loadingPodcasts: false });
      }
    }
  };

  render() {
    const last5Documents = this.last5ListenedDocuments(
      this.props.last5ListenedDocuments
    );
    const last5Flags = this.lastFlags(this.props.flags)[0];
    const allUserFlags = this.lastFlags(this.props.flags)[1];
    const allFlags = this.lastFlags(this.props.flagsByPodcast)[1];

    let podcasts = this.podcastsList(this.props.podcasts);

    let closePodcastModal = () => {
      this.setState({ podcastModal: false });
      this.props.dispatch(resetRssFeed());
    };

    let closePodcastEditModal = () =>
      this.setState({ podcastModalEdit: false });

    let userFields = this.props.userFields;

    let podcastSeasons =
      this.props.podcastSeasons !== null ? this.props.podcastSeasons : [];

    let allDocuments =
      this.props.allDocuments !== null ? this.props.allDocuments : [];

    const selectedPodcast = {
      id: this.state.id,
      podcastId: this.state.podcastId,
      podcastName: this.state.podcastName,
      artistName: this.props.allDocuments[0]?.artistName,
      imageUrl: this.state.podcastImageUrl,
      feedUrl: this.state.feedUrl,
      webPodcast: this.state.webPodcast,
      authScheme: this.state.authScheme,
      description: this.state.podcastDesc,
      enterpriseType: this.state.enterpriseType,
      isOwner: this.state.isOwner
    };

    return (
      <React.Fragment>
        <Dialog
          ref={(el) => {
            this.dialog = el;
          }}
        />
        <ModalPodcast
          show={this.state.podcastModal}
          onHide={closePodcastModal}
          updateDashboard={this.updateDashboard}
        />
        <ModalPodcastEdit
          show={this.state.podcastModalEdit}
          onHide={closePodcastEditModal}
          name={this.state.podcastName}
          feedUrl={this.props.feedUrl}
          imageUrl={this.state.podcastImageUrl}
          artistName={this.state.artistName}
          podcastId={this.state.podcastId}
        />
        {this.state.shareModalOpen && (
          <ShareFlags
            open={this.state.shareModalOpen}
            onClose={this.handleShareModalClose}
            flagsToShare={this.state.flagsToShare}
          />
        )}
        <div>
          <div ref={this.myNav}>
            <Navigation />
          </div>
          <div className="main-page" style={{ padding: 0, margin: 0 }}>
            <div
              className="dashboard-content-container"
              style={{ padding: 0, margin: 0 }}
            >
              <div
                className={
                  this.props.expand
                    ? 'dashboard-sidebar disappear'
                    : 'dashboard-sidebar'
                }
              >
                <DashboardSidebar
                  last5Documents={last5Documents}
                  isPaused={this.props.isPaused}
                  playingDocumentId={this.props.playingDocumentId}
                  last5Flags={last5Flags}
                  notifications={this.props.notifications}
                  onRowClickFlag={this.onRowClickFlag}
                  onClickLastListened={this.onRowClickDocument}
                  openShareModal={this.handleShareModalInit}
                />
              </div>
              <div
                className={
                  this.props.expand
                    ? 'right-column dashboard-main-area-expand dash-panel'
                    : 'right-column dashboard-main-area dash-panel'
                }
                style={{ padding: 0 }}
              >
                <Tab.Container
                  defaultActiveKey="1"
                  activeKey={this.state.key}
                  onSelect={this.handleSelect}
                  id="controlled-tab"
                >
                  <Row>
                    <Col
                      sm={12}
                      className={
                        this.props.expand ? 'tabs_row disappear' : 'tabs_row'
                      }
                    >
                      <Nav bsStyle="pills">
                        <NavItem eventKey="1" className="pills-item">
                          Subscribed
                        </NavItem>
                        <NavItem eventKey="3" className="pills-item">
                          Documents
                        </NavItem>
                        <NavItem eventKey="4" className="pills-item">
                          Playlists
                        </NavItem>
                      </Nav>
                    </Col>
                    <Col
                      sm={12}
                      className="tabs-content__column panel-24 panel-24-gradient"
                      style={{ padding: 0 }}
                    >
                      <Tab.Content>
                        <Tab.Pane eventKey="1">
                          <InfiniteScrollWrapper
                            dataLength={this.state.podcasts.length}
                            next={this.loadMorePodcasts}
                            hasMore={this.state.hasMorePodcasts}
                            scrollThreshold={0.2}
                          >
                            <DashboardSubscribedTab
                              id={this.state.id}
                              decoration={this.state.decoration}
                              search={this.debouncedSearch}
                              searchBar={this.searchBar}
                              sortPodcast={this.sortPodcast}
                              podcastsTab={podcasts}
                              searchUi={this.state.searchUi}
                              reloadDocumentsAndFlags={
                                this.reloadDocumentsAndFlags
                              }
                              fetchingPodcasts={this.state.fetchingPodcasts}
                              podcastModal={this.podcastModal}
                              openMyProProp={this.state.openMyPro}
                              openMyPro={this.openMyPro}
                              openMyPodsProp={this.state.openMyPods}
                              openMyPods={this.openMyPods}
                            />
                          </InfiniteScrollWrapper>
                        </Tab.Pane>
                        <Tab.Pane eventKey="2">
                          <DashboardFlagsTab
                            ref={this.flagsTab}
                            id={this.state.id}
                            decoration={this.state.decoration}
                            withPodcastId={this.state.withPodcastId}
                            podcastImageUrl={this.state.podcastImageUrl}
                            podcastName={this.state.podcastName}
                            podcasts={podcasts}
                            allFlags={allFlags}
                            allUserFlags={allUserFlags}
                            loader={this.state.loader}
                            reloadDocumentsAndFlags={this.reloadDocumentsAndFlags}
                            isExpandableRow={this.isExpandableRow}
                            expandComponent={this.expandComponent}
                            expandColumnComponent={this.expandColumnComponent}
                            loading={this.setLoading}
                          />
                        </Tab.Pane>
                        <Tab.Pane eventKey="3">
                          <DocumentsTab
                            id={this.state.id}
                            allDocuments={allDocuments}
                            podcast={selectedPodcast}
                            withPodcastId={this.state.withPodcastId}
                            loader={this.state.loader}
                            reloadDocumentsAndFlags={this.reloadDocumentsAndFlags}
                            unsubscribe={this.unsubscribe}
                            feedUrl={this.props.feedUrl}
                            showPlayButton={this.state.showPlayButton}
                            userFields={userFields}
                            reload={this.state.reload}
                            neverListenToPodcast={this.neverListenToPodcast}
                            addToPlaylistHandler={this.addToPlaylistHandler}
                            loading={this.setLoading}
                            playDocuments={this.playDocuments}
                            onRowClickDocument={this.onRowClickDocument}
                            fetchDocumentsOfPodcast={this.fetchDocumentsOfPodcast}
                            setPdfViewerDocumentId={this.setPdfViewerDocumentId}
                            newFlags={this.props.flags}
                            setExpand={this.setExpand}
                            expand={this.props.expand}
                            setFilterByThumbs={this.setFilterByThumbs}
                            playingDocumentId={this.props.playingDocumentId}
                            isPaused={this.props.isPaused}
                            playerDocument={this.props.playerDocument}
                            onPlaySummary={this.handlePlaySummary}
                            onPlayDocument={this.handlePlayDocument}
                            onAddSummaryToPlaylist={
                              this.handleAddSummaryToPlaylist
                            }
                            onAdddocumentoPlaylist={
                              this.handleAdddocumentoPlaylist
                            }
                            handleSeasonChange={this.handleSeasonChange}
                            seasonCount={this.state.seasonCount}
                            podcastSeasons={podcastSeasons}
                            podcastType={this.state.podcastType}
                            podcastId={this.state.podcastId}
                            onShowPlayButton={(showPlayButton) =>
                              this.setState({ showPlayButton: showPlayButton })
                            }
                            playSerial={this.state.playSerial}
                            tabKey={this.state.key}
                            goToNextSeasonFromSeeAll={
                              this.state.goToNextSeasonFromSeeAll
                            }
                            isLoadingDocuments={this.state.isLoadingDocuments}
                            setIsLoadingDocuments={(value) =>
                              this.setState({ isLoadingDocuments: value })
                            }
                            isPodcastUnavailable={
                              this.state.isPodcastUnavailable
                            }
                            setIsPodcastUnavailable={(isPodcastUnavailable) =>
                              this.setState({
                                isPodcastUnavailable: isPodcastUnavailable
                              })
                            }
                            hasMoreDocuments={this.state.hasMoreDocuments}
                            setHasMoreDocuments={(value) =>
                              this.setState({ hasMoreDocuments: value })
                            }
                          />
                        </Tab.Pane>
                        <Tab.Pane eventKey="4">
                          <PlaylistsTab
                            playlists={this.state.playlists}
                            onPlayDocument={this.onRowClickDocument}
                            documentDeleted={this.state.documentDeleted}
                            onDocumentDeleted={this.handleDocumentDeleted}
                          />
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
                {this.state.addToPlaylist && (
                  <AddToPlaylistModal
                    title="Add document to playlist"
                    show={this.state.addToPlaylist}
                    onClose={() => this.addToPlaylistHandler(false, null)}
                    documentoAdd={this.state.documentoAdd}
                    parentCallback={this.reloadPlaylists}
                  />
                )}

                <ModalWrapper
                  title="Podcast authentication required"
                  show={this.state.showSignInModal}
                  onClose={this.closeSignInModal}
                >
                  <LoginForm
                    podcast={this.props.feedUrl}
                    onCancel={this.closeSignInModal}
                    onSubmit={this.submitLogInForm}
                  />
                </ModalWrapper>
              </div>
            </div>
          </div>
        </div>
        <div style={{ height: '20px' }}></div>
        <div style={{ height: '20px' }}></div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    documents: store.app.documents,
    flags: store.app.flags,
    podcasts: store.app.podcasts,
    flagsByPodcast: store.app.flagsByPodcast,
    documentsByPodcast: store.app.documentsByPodcast,
    last5ListenedDocuments: store.app.last5ListenedDocuments,
    listeningToDocument: store.app.listeningToDocument,
    playbackPlaylist: store.app.playbackPlaylist,
    showOnBoardingMsg: store.user.showOnBoardingMsg,
    playingDocumentId: store.app.playingDocumentId,
    playingFromListenNowPlaylist: store.app.playingFromListenNowPlaylist,
    documentInListenNowHasFullProgress:
      store.app.documentInListenNowHasFullProgress,
    userFields: store.app.userFields,
    playerDocument: store.player.playerDocument,
    forward: store.player.forward,
    backward: store.player.backward,
    isPaused: store.player.isPaused,
    flagAdded: store.player.flagAdded,
    allDocuments: store.player.allDocuments,
    fullDocuments: store.player.fullDocuments,
    allSeasons: store.player.allSeasons,
    fromPlaylistTab: store.player.fromPlaylistTab,
    storeProgress: store.player.storeProgress,
    feedUrl: store.player.feedUrl,
    newDocumentInLast5: store.player.newDocumentInLast5,
    season: store.player.season,
    fromSkip: store.player.fromSkip,
    podcastSeasons: store.player.podcastSeasons,
    notifications: store.app.notifications,
    pdfViewerDocumentId: store.pdf.pdfViewerDocumentId,
    expand: store.pdf.expand,
    tags: store.flag.tags,
    podcastUser: store.user.podcastUser,
    dashboardPodcastsPage: store.app.dashboardPodcastsPage,
    documentsSearchValue: store.app.documentsSearchValue,
    dashboardDocumentsPage: store.app.dashboardDocumentsPage
  };
};

const authCondition = (authUser) => {
  return (
    !!authUser &&
    (isUserStatusSubscribed(authUser.userStatus) ||
      isUserStatusFree(authUser.userStatus)) &&
    (authUser.subscriptionType === undefined ||
      isSubscriptionTypePro(authUser.subscriptionType) ||
      isSubscriptionTypeElite(authUser.subscriptionType))
  );
};

export default withAuthorization(authCondition)(
  connect(mapStateToProps)(DashboardPage)
);
